// extracted by mini-css-extract-plugin
export default {"list__btn":"styles_list__btn__r5IQL","list__edit":"styles_list__edit__rgLlU","list__clear":"styles_list__clear__fR02U","list":"styles_list__ETYXE"};